import { Dispatch, SetStateAction } from 'react';
import { Group, Pill } from '@mantine/core';
import { useViewDataset } from '@/hooks/useViewDataset.ts';
import { LinkedDataset } from '@/types/datasets.ts';

type props = {
  linkedDataset: LinkedDataset;
  setDatasetToDelete: Dispatch<SetStateAction<LinkedDataset | undefined>>;
};

// TODO: replace with FileItem?

const LinkedDatasetBadge = ({ linkedDataset, setDatasetToDelete }: props) => {
  // const Icon =
  //   linkedDataset.dataset_type === DatasetType.Directory ? HiOutlineFolder : HiOutlineDocument;

  // const [clickedDataset, setClickedDataset] = useState<LinkedDataset | undefined>(undefined);

  // useEffect(() => {
  //   if (error) {
  //     setClickedDataset(undefined);
  //     notifications.show({
  //       title: 'No linked dataset found',
  //       message: 'Did you just link this dataset? If so, wait a bit and try again',
  //       color: 'red',
  //       autoClose: 10000,
  //     });
  //   }
  // }, [error]);

  const { setDatasetModalId } = useViewDataset();

  // useEffect(() => {
  //   if (linkedDataset.latest_dataset) {
  //     setClickedDataset(undefined);
  //     setDatasetModalId(linkedDataset.latest_dataset.id);
  //   }
  // }, [linkedDataset.latest_dataset, setDatasetModalId]);

  return (
    <Pill
      key={linkedDataset.id}
      withRemoveButton={true}
      onRemove={() => setDatasetToDelete(linkedDataset)}
      styles={{ label: { alignItems: 'center' } }}
    >
      <Group
        gap={'4px'}
        wrap={'nowrap'}
        onClick={(e) => {
          // if (linkedDataset.dataset_type === DatasetType.Directory) {
          //   return;
          // }
          e.preventDefault();
          e.stopPropagation();
          if (linkedDataset.latest_dataset) {
            setDatasetModalId(linkedDataset.latest_dataset.id);
          }
        }}
        style={{ cursor: 'pointer' }}
        // style={{ cursor: linkedDataset.dataset_type !== DatasetType.Directory ? 'pointer' : 'default'}}
      >
        {/*{loadingLatestDataset ? <CustomSpinner size={'14px'} /> : <Icon size={14} style={{}} />}*/}
        {linkedDataset.name}
      </Group>
    </Pill>
  );
};

export default LinkedDatasetBadge;
